import { useNavigate } from "react-router-dom";
import { Minus, Plus, ShoppingBag, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { formatZAR, useShop } from "./ShopContext";
import { ProductImage } from "./ProductCard";

export const QtyStepper = ({ value, onChange, max, testid }) => (
  <div className="inline-flex items-center rounded-full border border-slate-300" data-testid={testid}>
    <button type="button" className="p-1.5 text-slate-600 hover:text-[#D96B27]" onClick={() => onChange(value - 1)} data-testid={`${testid}-minus`}><Minus className="h-3.5 w-3.5" /></button>
    <span className="w-8 text-center text-sm font-bold" data-testid={`${testid}-value`}>{value}</span>
    <button type="button" className="p-1.5 text-slate-600 hover:text-[#D96B27] disabled:opacity-30" disabled={max != null && value >= max} onClick={() => onChange(value + 1)} data-testid={`${testid}-plus`}><Plus className="h-3.5 w-3.5" /></button>
  </div>
);

export const CartLines = () => {
  const { cart, setQty } = useShop();
  return cart.map((l) => (
    <div key={l.product_id} className="flex gap-3 border-b border-slate-100 py-3" data-testid={`cart-line-${l.plu_code}`}>
      <div className="h-16 w-16 shrink-0 rounded-lg bg-slate-50 p-1"><ProductImage src={l.image_url} alt={l.name} /></div>
      <div className="min-w-0 flex-1">
        <p className="line-clamp-2 text-sm font-semibold text-slate-800">{l.name}</p>
        <p className="text-sm font-bold text-slate-900">{formatZAR((l.your_price ?? l.price) * l.quantity)}</p>
        <div className="mt-1 flex items-center gap-2">
          <QtyStepper value={l.quantity} max={l.available} onChange={(q) => setQty(l.product_id, q)} testid={`cart-qty-${l.plu_code}`} />
          <button type="button" className="text-slate-400 hover:text-rose-600" onClick={() => setQty(l.product_id, 0)} data-testid={`cart-remove-${l.plu_code}`}><Trash2 className="h-4 w-4" /></button>
        </div>
      </div>
    </div>
  ));
};

export const CartDrawer = () => {
  const { cart, cartOpen, setCartOpen, cartTotal } = useShop();
  const navigate = useNavigate();
  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent className="flex w-full flex-col sm:max-w-md" data-testid="cart-drawer">
        <SheetHeader><SheetTitle className="flex items-center gap-2"><ShoppingBag className="h-5 w-5 text-[#D96B27]" /> Your cart</SheetTitle></SheetHeader>
        <div className="-mx-2 flex-1 overflow-y-auto px-2">
          {cart.length === 0 ? <p className="py-12 text-center text-sm text-slate-500" data-testid="cart-empty">Your cart is empty</p> : <CartLines />}
        </div>
        {cart.length > 0 && (
          <div className="border-t pt-4">
            <div className="mb-1 flex justify-between text-base font-bold"><span>Total</span><span data-testid="cart-total">{formatZAR(cartTotal)}</span></div>
            <p className="mb-3 text-xs text-slate-500">Collect FREE in store · Pay when you collect</p>
            <button type="button" onClick={() => { setCartOpen(false); navigate("/shop/checkout"); }}
              className="w-full rounded-full bg-[#D96B27] py-3 font-bold text-white transition-colors hover:bg-[#C2591B]" data-testid="cart-checkout-btn">
              Checkout
            </button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
